import { createContext, useContext } from 'react';
import { StockType } from 'models/stock.model';

export type IRequest = {
  name: string;
  id: string;
  quantity: string;
  vendor: {
    id: string;
    name: string;
    price: string;
  };
  measurement: string;
};
export type InventoryStockContextType = {
  requests: IRequest[];
  setRequests: (requests: IRequest[]) => void;
  isPreview: boolean;
  setIsPreview: (isPreview: boolean) => void;
  selectedRequests: IRequest[];
  vendorsArray: {
    name: string;
    price: string;
    id: string;
  }[];
  scrollIndex: number | null;
  setScrollIndex: (index: number | null) => void;
  stocksToEdit: StockType[];
  setStocksToEdit: (stocks: StockType[]) => void;
  stockToRecordWastage: StockType | null;
  setStockToRecordWastage: (stocks: StockType | null) => void;
};

export const InventoryStockContext = createContext({} as InventoryStockContextType);
const useInventoryStockContext = () => {
  const context = useContext(InventoryStockContext);
  return context;
};

export default useInventoryStockContext;
